import React, { useRef, useState } from "react";
import { Tooltip, Popover } from "@mui/material";
import { IconButton } from "@mui/material";
import AsiaCup2025 from '../../../images/AsiaCup2025.png'

const MessageA1 = (props) => {
  const [clicked, setClicked] = useState(false);

  let parsedData = null;
  try {
    parsedData = props?.item?.data ? JSON.parse(props.item.data) : null;
  } catch {
    // ignore
  }
  const isLive = parsedData?.show === "live";

  const getButtonContent = () => (
    <>
      {parsedData?.img && (
        <img src={parsedData.img} alt={props?.item?.text} style={{  width:isLive ? "38px" : "24px", height: "24px", opacity: 0.9, mixBlendMode: "darken" }} />
      )}
      {props?.item?.text}
      <span className={`a1-live-indicator ${clicked ? "a1-live-paused" : ""}`}>LIVE</span>
    </>
  );

  // const checkButton = () => {
  //   let userText = props?.item?.text;
  //   const buttonTextOptions = ["Yes", "No", "Submit", "Confirm" ,"Send OTP"];
  //   // Check if any of the options are included in userText
  //   if (buttonTextOptions.some(option => userText.includes(option))) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  const checkButton = () => {
    let userText = props?.item?.text;
    const buttonTextOptions = ["Yes", "No", "Submit", "Confirm", "Send OTP", "Got it"];
  
    return buttonTextOptions.includes(userText);
  };

  const onClickHandler = (e) => {
    if (!props.disable) {
      props.handleClick(props.item.code);
      props.setTextOnClick(props.item.text);
      props.setSubTextOnClick(props?.item?.infoText || '')
      setClicked(true);
    }
  };

  return (
    <>
      {props?.item?.infoText && props?.item?.text != "Chat with Agent" ? (
        <Tooltip
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

              }}           
            >
              
              <h1 style={{ fontSize: 13, margin: 0 }}>{props?.item?.infoText}</h1>
            </div>
          }
          placement="top"
          arrow
          PopperProps={{
            modifiers: [
              {
                name: "preventOverflow",
                options: {
                  boundary: "window",
                },
              },
              {
                name: "offset",
                options: {
                  offset: [0, -5], // Adjust this value to move it closer (reduce the negative value to bring it down)
                },
              },
            ],
          }}
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "rgba(34, 0, 70, 0.75);",
                color: "#fff", // Tooltip text color
                fontSize: "12px",
                padding: "6px 10px", // Adjust padding if needed
              },
            },
            arrow: {
              sx: {
                color: "rgba(34, 0, 70, 0.75);", // Arrow should match tooltip background color
              },
            },
          }}
        >
          <button
            className={
              !props.disable
                ? "chat-label action-tab"
                : "chat-labelnohover action-tab"
            }
            id="main-tab1"
            style={{
              color: clicked && "grey",
              pointerEvents: clicked && "none",
              borderRadius: "44px",
            }}
            onClick={onClickHandler}
            ref={(el) => {
              if (el) {
                try {
                  const { color } = JSON.parse(props?.item?.data || "{}");
                  if (color) {
                    el.style.setProperty("background-color", color, "important");
                    el.style.setProperty("color", "white", "important");
                  }
                } catch {
                  // ignore parsing errors
                }
              }
            }}
          >
            {isLive ? getButtonContent() : props.item.text}
          </button>
        </Tooltip>



      ) : props?.isFallback && props?.item?.text === "Chat with Agent" ? (
        <>
          <button
            className={
              props.isFallback
                ? "chat-label-fallback action-tab"
                : "chat-labelnohover action-tab"
            }
            id="main-tab1"
            style={{
              color: clicked && "grey",
              pointerEvents: clicked && "none",
              borderRadius: "44px",
            }}
            onClick={onClickHandler}
          >
            {props?.item?.text}
          </button>
        </>
      ) : props?.item?.text === "Chat with Agent" ? (
        <>
          <button
            // className={"chat-label-fallback" }
            className='chat-label-fallback action-tab disabled-white'
            id="main-tab1"
            style={{
              pointerEvents: clicked && "none",
              cursor: clicked && "not-allowed",
              color: clicked && "white",
              opacity: clicked && "0.5",
            }}
            onClick={onClickHandler}
          >
            {props?.item?.text}
          </button>
        </>
      ) : (
        <button
          className={
            props.isFallback
              ? "chat-label action-tab"
              : `${props?.item?.text === "Upload Image" ? "chat-label-fallback" : "chat-label"} `
          }
          id="main-tab1"
          style={{
            color: clicked && "grey",
            pointerEvents: clicked && "none",
            borderRadius: checkButton() ? "4px" : "44px",
            position: "relative",
            overflow: "visible", // allow badge outside
            paddingRight: "16px", // some breathing room
            
          }}
          onClick={onClickHandler}
          ref={(el) => {
            if (el) {
              try {
                const { color } = JSON.parse(props?.item?.data || "{}");
                if (color) {
                  el.style.setProperty("background-color", color, "important");
                  el.style.setProperty("color", "white", "important");
                }
              } catch {
                // ignore parsing errors
              }
            }
          }}
        >
          {isLive ? getButtonContent() : (
            <>
              {(() => {
                try {
                  const parsed = JSON.parse(props?.item?.data || "{}");
                  if (parsed?.img) {
                    return (
                      <img
                        src={parsed?.img}
                        alt={props?.item?.text}
                        style={{
                          width:isLive ? "38px" : "24px",
                          height: "24px",
                          opacity: 0.9,
                          mixBlendMode: "darken",
                        }}
                      />
                    );
                  }
                } catch {
                  return null;
                }
                return null;
              })()}
              {props?.item?.text}
            </>
          )}

          {/* NEW Tag */}
          {(() => {
            try {
              const parsed = JSON.parse(props?.item?.data || "{}");
              return parsed?.button === "new" ? (
                <span
                  style={{
                    position: "absolute",
                    top: "-12px",    // move above button
                    right: "4px",    // align with right corner
                    background: "red",
                    color: "white",
                    fontSize: "10px",
                    fontWeight: "bold",
                    padding: "2px 6px",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                    marginLeft: '6px'
                  }}
                >
                  NEW
                </span>
              ) : null;
            } catch {
              return null;
            }
          })()}
        </button>

      )}
    </>
  );
};

export default MessageA1;
